export default __webpack_public_path__ + "static/media/development_black.95e6e44c.svg";